import { combineReducers } from '@reduxjs/toolkit'
import { layoutReducer } from '@web/app/components'
import { accessReducer } from '@web/app/features/access'
import { persistedAuthReducer } from '@web/app/features/auth'
import documentExplorerReducer from '@web/app/features/firmas/store/documentExplorerSlice'
import firmasReducer from '@web/app/features/firmas/store/firmasSlice'
import { publicVerifyApi } from '@web/app/features/publicVerify'
import { appApi } from '@web/app/store/api'
import notificationsReducer from '@web/app/store/notificationsSlice'

export const rootReducer = combineReducers({
  [appApi.reducerPath]: appApi.reducer,
  [publicVerifyApi.reducerPath]: publicVerifyApi.reducer,
  ...persistedAuthReducer,
  ...layoutReducer,
  ...accessReducer,
  firmas: firmasReducer,
  documentExplorer: documentExplorerReducer,
  notifications: notificationsReducer,
})
